import { createContext } from "react";

/**
 * Today's own `climbLogs/{uid}_{today}` document, as the shell's single live
 * listener (`todayClimbLog` in `useGymData`) delivers it. The Spraywall tab
 * provides it so `useSprayLog` reads the spray half of today's log (cooldown
 * check, spray totals) without a second listener on the same document and
 * without threading the prop through the tab, pane and problem / list views.
 * `undefined` = no provider (tests); `null` = no document today.
 */
export const TodayClimbLogContext = createContext(undefined);
